import MAdmin from './admin.menu'
import MStudent from './student.menu'
import MSecurity from './security-personel.menu'
import { extractRoleCode } from '@/config/roles'

const SUPERUSER_ONLY_MENU_ROUTES = ['admin.activity-logs']

const toRoleAwareAdminMenus = roleCode => {
  if (roleCode === 'superuser') {
    return MAdmin
  }

  return MAdmin.filter(item => !SUPERUSER_ONLY_MENU_ROUTES.includes(item?.link?.name))
}

export const getSidebarMenus = user => {
  const roleCode = extractRoleCode(user)

  switch (roleCode) {
    case 'admin': {
      return toRoleAwareAdminMenus(roleCode)
    }
    case 'superuser': {
      return toRoleAwareAdminMenus(roleCode)
    }
    case 'student': {
      return MStudent
    }
    case 'security_personel':
    case 'dsm': {
      return MSecurity
    }
    default: {
      return []
    }
  }
}
